import { baseUrlRouter } from "./config";
import { loadFromLocalStorage } from "./localStorageManager";
import appApi from "../api/appApi";
import store from "../store";
import { userSetInformations } from "../actions/userActions";
import { loginSuccess } from "../actions/loginActions";
import { appRequestUserlistEnd } from "../actions/appActions";
import { initAxiosInstanceToken } from "./axios";

let checkUserLoggedIn = props => {
	const userInformationStorage = loadFromLocalStorage("userInformations");
	const userListStorage = loadFromLocalStorage("userList");

	if (userInformationStorage) {
		if (!props.logged && userInformationStorage.token) {
			initAxiosInstanceToken(userInformationStorage.token);
		}
		appApi
			.checkUserToken(userInformationStorage.token)
			.then(res => {
				if (!props.logged) {
					if (userInformationStorage.superAdmin) {
						store.dispatch(appRequestUserlistEnd(userListStorage));
					}
					store.dispatch(
						userSetInformations(
							userInformationStorage.login,
							userInformationStorage.superAdmin,
							userInformationStorage.targetDirectories,
							userInformationStorage.token,
							userInformationStorage.environment,
							userInformationStorage.accountMetadataLabel,
							userInformationStorage.uipreferences,
							userInformationStorage.uploadEnabled
						)
					);
					store.dispatch(loginSuccess(userInformationStorage.token));
				}
			})
			.catch(err => {
				props.history.push(baseUrlRouter);
			});
	} else if (!props.logged) {
		props.history.push(baseUrlRouter);
	} else {
	}
};

export { checkUserLoggedIn };



// WEBPACK FOOTER //
// ./src/utils/routerUtils.js